import 'reflect-metadata';
import { Service } from 'typedi';
import { StrategyBuilder } from '../../StrategyBuilder';
import { makeLogger } from '../../../../logger/logger';
import type { ITransformEventsNamesStrategyData } from '../../types/transform-events-names-srategy-data.type';
import { TransformEventsNamesStrategyService } from '../../TransformEventsNamesStrategyService';

const { info } = makeLogger({
  pathToCurrentFile:
    'components/strategies/services/transform-events-names-service/transform-events-names-fallback.service.ts',
  loggersList: ['info'],
});

@Service({ id: 'transformEventsNamesFallbackStrategyService' })
export class TransformEventsNamesFallbackConfigurationBuilder extends StrategyBuilder<TransformEventsNamesStrategyService> {
  build(
    details: ITransformEventsNamesStrategyData
  ): TransformEventsNamesStrategyService {
      return new FallbackTransformEventsNamesStrategyService(details);
  }
}

export class FallbackTransformEventsNamesStrategyService extends TransformEventsNamesStrategyService {
  details;
  constructor(details: ITransformEventsNamesStrategyData) {
      super();
      this.details = details;
  }

  transformEventsNames(eventToDataLayer: Object): Object {
      info('Fallback - return the same event object unchanged');
      let transformedEvent = { ...eventToDataLayer, 'search_location': 'Site Search' };
      if(eventToDataLayer['search_location']){
        transformedEvent = {...eventToDataLayer, 'search_location': eventToDataLayer['search_location']};
      }

      return transformedEvent;
  }

}
